/* ══════════════════════════════════════════
   Datumsregeln für Veranstaltungen
   ──────────────────────────────────────────
   Reine Funktionen, kein React, keine API. Das ist der Grund für die eigene
   Datei: die Regeln standen in Start.js, und Start.js zieht über App.js die
   halbe Anwendung mit — ein Test dafür kam nicht einmal bis zum ersten
   `expect`. Datumsgrenzen sind aber genau das, was man prüfen will.
   ══════════════════════════════════════════ */

export const MONATE = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];

/* Nach dem Ende bleibt eine Veranstaltung noch zwei Wochen in der Hauptliste.
   Direkt danach schaut man oft nochmal in die Teilnehmerliste; erst wenn das
   erledigt ist, soll sie aus dem Blickfeld. */
export const SCHONFRIST_TAGE = 14;
const SCHONFRIST_MS = SCHONFRIST_TAGE * 24 * 60 * 60 * 1000;

export function alsDatum(v) {
  if (!v) return null;
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
}

/* Fehlt date_from, gilt date_to — und umgekehrt. Eine Veranstaltung ohne
   jedes Datum bekommt 0, landet in der Sortierung also hinten. */
export const beginn = ev => alsDatum(ev?.date_from || ev?.date_to)?.getTime() ?? 0;
export const ende   = ev => alsDatum(ev?.date_to || ev?.date_from)?.getTime() ?? null;

/* Ohne verwertbares Datum bleibt eine Veranstaltung sichtbar — lieber eine
   Zeile zu viel in der Hauptliste als eine, die niemand mehr findet.
   Die Grenze ist „mehr als 14 Tage": genau am vierzehnten Tag noch da. */
export function istArchiviert(ev, jetzt) {
  const e = ende(ev);
  return e !== null && e + SCHONFRIST_MS < jetzt;
}

/* Neueste oben, in der Hauptliste wie im Archiv. */
export const neuesteZuerst = (a, b) => beginn(b) - beginn(a);
/* Die Veranstaltung, die nach Login vorausgewählt wird: diejenige, die gerade
   läuft oder als nächste anfängt — nicht die, die je zuerst angelegt wurde.
   Unter allen, die noch nicht zu Ende sind, zählt das früheste Ende; ist
   alles vorbei, die neueste. Veranstaltungen ohne verwertbares Datum machen
   nicht mit — sind es alle, wird nichts vorausgewählt (null). */
export function naechsteVeranstaltung(evs, jetzt = Date.now()) {
  if (!evs?.length) return null;
  const mitEnde = evs.filter((ev) => ende(ev) !== null);
  if (!mitEnde.length) return null;
  const kommende = mitEnde.filter((ev) => ende(ev) >= jetzt);
  if (kommende.length) return kommende.reduce((a, b) => (ende(a) <= ende(b) ? a : b));
  return mitEnde.reduce((a, b) => (ende(a) >= ende(b) ? a : b));
}

/* Zeitraum in einer Zeile. Gleicher Monat wird nicht zweimal genannt. */
export function zeitraum(from, to) {
  const f = alsDatum(from), t = alsDatum(to);
  if (!f && !t) return '';
  if (!f) return t.toLocaleDateString('de-DE');
  if (!t) return f.toLocaleDateString('de-DE');
  if (f.toDateString() === t.toDateString()) return f.toLocaleDateString('de-DE');
  const opts = { day: 'numeric', month: 'long', year: 'numeric' };
  if (f.getFullYear() === t.getFullYear() && f.getMonth() === t.getMonth())
    return `${f.getDate()}.–${t.toLocaleDateString('de-DE', opts)}`;
  return `${f.toLocaleDateString('de-DE', opts)} – ${t.toLocaleDateString('de-DE', opts)}`;
}
